export default __webpack_public_path__ + "static/media/RedballVerizonConnect.abd2f672.svg";